export const FACEBOOK_APP_ID = process.env.NEXT_PUBLIC_FACEBOOK_APP_ID ?? '431351161866019';
export const DEPLOY_ENV = process.env.NEXT_PUBLIC_DEPLOY_ENV ?? 'development';
export const DD_APP_ID =
  process.env.NEXT_PUBLIC_DATADOG_APP_ID ?? 'e753a6ff-83ee-45bd-95b2-9b04770e32ed';
export const DD_CLIENT_TOKEN =
  process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN ?? 'pubfb82f2d5a3b9c0fb99b4d6ab0c6c102b';
export const DD_PROXY = process.env.NEXT_PUBLIC_DATADOG_PROXY ?? 'https://rp.influitives.com/';
export const DATADOG_API_KEY =
  process.env.NEXT_PUBLIC_DATADOG_API_KEY ?? 'cff63bd6f5e4c9ee636e2be11a3cd9b4'; // AI-GEN - Cursor GPT4
export const RELEASE_VERSION = process.env.NEXT_PUBLIC_RELEASE_VERSION;
